export const DURATIONS = {
  15: '00:15',
  30: '00:30',
  60: '01:00'
};
